<mat-card [style.background-color]="uiData.firm.color">
    <h2 mat-dialog-title>
        <mat-icon>call_merge</mat-icon> Merge Firms
    </h2>
</mat-card>
<mat-dialog-content class="scroll-container">
    <section *ngIf="loading">
        <h2>Loading...</h2>
        <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading...">
        </mat-progress-bar>
    </section>
    <mat-card *ngIf="!loading">
        <div>
            <p color="primary">
                <strong>Note:</strong> This feature will merge all the Firms staff, contact information, certifications, credentials, and applications into the selected Firm
                below and set the non-selected Firms to be <strong>Deleted</strong>.
    
            </p>
    
            <br />
            <label>Select the Firm to keep below: <br /></label>
            <small>This Firm will absorb all staff, contact information, certifications, credentials and applications from the remaining unselected Firms.</small>
            <br />
            <br />
            <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                <ng-container *ngFor="let cellData of individualApplicationTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                    <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{cellData.displayName}}</mat-header-cell>
                    <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                        <ng-container *ngIf="cellData.type === 'date'">
                            <div *ngIf="isMobile" fxLayout="row">  
                                <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                            </div>
                            <div *ngIf="!isMobile">  
                                {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                            </div>
                        </ng-container>
                        
                        <ng-container *ngIf="cellData.type === 'boolean'">
                            <div *ngIf="isMobile" fxLayout="row">
                                <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                            </div>
                            <div *ngIf="!isMobile">
                                <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                            </div>                            
                        </ng-container>                       
                    
                        <ng-container *ngIf="cellData.type === 'select'">
                            <div *ngIf="isMobile" fxLayout="row">
                                <mat-radio-group [(ngModel)]="selectedFirm" (change)="onChangeSelectedPerson(row)">
                                    <mat-radio-button [value]="row"> 
                                        <!-- Radio button only, no label -->
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <div *ngIf="!isMobile">
                                <mat-radio-group [(ngModel)]="selectedFirm" (change)="onChangeSelectedPerson(row)">
                                    <mat-radio-button [value]="row"> 
                                        <!-- Radio button only, no label -->
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </ng-container>
                        

                        <ng-container *ngIf="cellData.type !== 'date' && cellData.type !== 'boolean' && cellData.type !== 'select'">
                            <div *ngIf="isMobile" fxLayout="row">                                    
                                <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                <span>{{ displayLimit(row[cellData.columnName], cellData.size) }}</span>
                            </div>
                            <div *ngIf="!isMobile">
                                {{ displayLimit(row[cellData.columnName], cellData.size) }}
                            </div>  
                        </ng-container>
                    </mat-cell>                    
                </ng-container>                                  
                                    
                <!-- Column definitions -->
                <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="individualApplicationTable.layout.columns"></mat-header-row>
                <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; index as i; columns: individualApplicationTable.layout.columns"></mat-row>
            </mat-table>
            <br />
            <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 5]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card>
</mat-dialog-content>
<mat-card [style.background-color]="uiData.firm.color">        
    <div>        
        <section *ngIf="merging">
            <h3>Merging...</h3>
            <mat-progress-bar mode="indeterminate" color="warn" aria-label="Merging...">
            </mat-progress-bar>
            <br>
        </section>
        <button mat-button [disabled]="selectedFirm === null || merging" mat-raised-button color="primary"(click)="merge()">
            <mat-icon>call_merge</mat-icon> Merge Firms
        </button>
            &nbsp;
        <button mat-button mat-raised-button mat-dialog-close="Cancel" aria-label="Cancel" [mat-dialog-close]="false" [disabled]='merging'>Cancel</button>
    </div>
</mat-card>